import React from 'react';
import { BiddingDataTypes } from 'interfaces/robot_dashboard';
import moment from 'moment';
import {
  dedupeBiddingsByPortalPrgCodOrgName,
  getBiddingUniqueKey,
} from 'services/utils/robot_dashboard_biddings';

interface DataTableItem {
  id: string;
  clientId: number;
  portal: string;
  prgCod: string;
  uasg: string;
  orgName: string;
  proposalFinalDate: string;
  disputeStartDate: string;
  status: string;
}

const ID_GROW = 0;
const PORTAL_GROW = 0;
const EDITAL_GROW = 0;
const UASG_GROW = 0;
const ORG_NAME_GROW = 3;
const DISPUTE_START_DATE_GROW = 2;
const STATUS_GROW = 1;

export const datatableData = (biddingsList: Array<BiddingDataTypes>) => {
  return dedupeBiddingsByPortalPrgCodOrgName(biddingsList).map((bidding) => {
    return {
      id: getBiddingUniqueKey(bidding),
      clientId: bidding.clientId,
      portal: bidding.portal || '',
      prgCod: bidding.prgCod || '',
      uasg: bidding.uasg || '',
      orgName: bidding.orgName || '',
      proposalFinalDate: bidding.proposalFinalDate || '',
      disputeStartDate: bidding.disputeStartDate || '',
      status: bidding.status,
    };
  });
};

export const datatableColumns = () => {
  return [
    {
      name: 'ID',
      width: '110px',
      sortable: true,
      selector: (data: DataTableItem) => data.clientId,
      center: false,
      grow: ID_GROW,
      cell: (data: DataTableItem) => <div>{data.clientId}</div>,
    },
    {
      name: 'Portal',
      width: '220px',
      sortable: true,
      selector: (data: DataTableItem) => data.portal,
      center: false,
      grow: PORTAL_GROW,
      cell: (data: DataTableItem) => (
        <div>
          {data.portal.replace(/_/g, '').replace(/(?:^|\s)\w/g, (match) => match.toUpperCase())}
        </div>
      ),
    },
    {
      name: 'N. Pregão',
      width: '130px',
      sortable: true,
      selector: (data: DataTableItem) => data.prgCod,
      center: false,
      grow: EDITAL_GROW,
      cell: (data: DataTableItem) => <div>{data.prgCod}</div>,
    },
    {
      name: 'UASG',
      sortable: true,
      selector: (data: DataTableItem) => data.uasg,
      center: false,
      grow: UASG_GROW,
      cell: (data: DataTableItem) => <div>{data?.uasg ? data.uasg : '--'}</div>,
    },
    {
      name: 'Nome',
      sortable: true,
      selector: (data: DataTableItem) => data.orgName,
      center: false,
      grow: ORG_NAME_GROW,
      cell: (data: DataTableItem) => <div>{data.orgName}</div>,
    },
    {
      name: 'Abertura de Lances',
      width: '170px',
      sortable: true,
      selector: (data: DataTableItem) => data.disputeStartDate,
      center: false,
      grow: DISPUTE_START_DATE_GROW,
      cell: (data: DataTableItem) => (
        <div>
          {data.disputeStartDate ? moment(data.disputeStartDate).format('DD/MM/YYYY, HH:mm') : '--'}
        </div>
      ),
    },
    {
      name: 'Status',
      width: '130px',
      sortable: true,
      selector: (data: DataTableItem) => data.status,
      center: false,
      grow: STATUS_GROW,
      cell: (data: DataTableItem) => (
        <div>
          {data.status === 'Cadastrada' && (
            <span className="badge badge-secondary">{data.status}</span>
          )}
          {data.status === 'Configurada' && (
            <span className="badge badge-primary">{data.status}</span>
          )}
          {data.status === 'Encerrada' && <span className="badge badge-danger">{data.status}</span>}
          {data.status === 'Em Disputa' && (
            <span className="badge badge-success">{data.status}</span>
          )}
        </div>
      ),
    },
  ];
};
